import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ServerService } from '../../service/server/server.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import Num2persian from 'num2persian';
import { CkdMaterial2DetaileComponent } from '../ckd-material2-detaile/ckd-material2-detaile.component';
import { MessageService } from '../../service/message/message.service';


@Component({
  selector: 'app-ckd-material2',
  templateUrl: './ckd-material2.component.html',
  styleUrls: ['./ckd-material2.component.scss']
})
export class CkdMaterial2Component implements OnInit, OnDestroy {
  public server: any = this.serverService.get_server();
  public user_info: any = JSON.parse(<any>localStorage.getItem("user_info"));
  public lang: any = 1;
  public loading = false;
  public subscription: Subscription;
  public title: string | undefined;
  public id: number | undefined;
  public list_record: any = [];
  public list_record_length = 1;
  public user_id: number | undefined;
  public search: string;
  public cate: number | undefined;
  public form1: FormGroup;
  public ckd_id: number | undefined;
  public sum_all: number = 0;
  public sum_all_letter: string | undefined;
  public seleton_id: number | undefined;
  public weight: number | undefined;
  public tip: number | undefined;
  public mat_table_selectedRow: any;
  public dataSource: any | undefined;
  public displayedColumns = ['row', 'title', 'cate2', 'number', 'weight', 'price', 'zarayeb', 'discount', 'sum', 'operation'];


  constructor(
    public serverService: ServerService
    , public router: Router
    , public matSnackBar: MatSnackBar
    , public matDialogRef: MatDialogRef<CkdMaterial2Component>
    , public dialog: MatDialog
    , public messageService: MessageService
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any) {

    if (this.dialog) {
      this.id = dialog_data.id;
      this.cate = dialog_data.cate;
      this.title = dialog_data.title;
      this.ckd_id = dialog_data.cdk_id;
      this.seleton_id = dialog_data.seleton_id;
      this.tip = dialog_data.tip;
    }

  }//end consructor

  ngOnInit() {
    this.user_id = this.user_info.user_id;
    this.form1 = new FormGroup({
      'material': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')]),
      'material_title': new FormControl(null),
      'cate2_title': new FormControl(null),
      'cate2': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')])
    })
    this.get_material(1);
  }

  check_access(type_task: number, page: number, id: any, excel: number, loading: number): any {
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: 222 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            this.message(true, this.messageService.access2(this.lang), 1, this.messageService.close(this.lang));
          }
          else {
            this.loading = false;
            if (type_task == 3) {
              this.delete(id);
            }
          }
        }//end if
        else {
          this.message(true, this.messageService.access(this.lang), 1, this.messageService.close(this.lang));
        }
      }
    )
  }

  get_material(type: number): any {
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 10562, cate: this.cate, ckd_id: this.ckd_id, seleton_id: this.seleton_id }).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.sum_all += res['result'][i].sum;
            this.list_record.push(res['result'][i]);
          }
          this.sum_all_letter = Num2persian(this.sum_all);
          this.dataSource = new MatTableDataSource(this.list_record)
          this.message(false, "", 1, this.messageService.close(this.lang));
        }//end if 
        else {
          this.message(true, this.messageService.erorr_in_load(this.lang), 1, this.messageService.close(this.lang));
        }
      }
    )
  }

  check_for_repeat() {
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1.valid) {
      return false;
    }
    this.loading = true;
    var obj = {
      address: 10653
      , material_id: this.form1.value.material
      , ckd: this.ckd_id
      , cate2: this.form1.value.cate2
      , cate: this.cate
      , weight: this.weight
      , tip: this.tip
      , meter: this.form1.value.meter
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 0) {
            this.insert_material();
          }
          else {
            var pe_message = " شما نمی توانید کالای مشابه اضافه کنید.";
            this.message(true, this.messageService.message(this.lang, pe_message, ''), 1, this.messageService.close(this.lang))
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(this.lang), 1, this.messageService.close(this.lang))
        }
      }
    )
  }

  insert_material() {
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1.valid) {
      return false;
    }
    this.loading = true;
    var obj = {
      address: 10564
      , material_id: this.form1.value.material
      , ckd: this.ckd_id, cate2: this.form1.value.cate2
      , cate: this.cate
      , weight: this.weight
      , tip: this.tip
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.sum_all += res['result'][0].sum;
          this.sum_all_letter = Num2persian(this.sum_all)
          this.list_record.unshift(res['result'][0]);
          this.dataSource.data = this.list_record;
          this.message(false, "", 1, this.messageService.close(this.lang));
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(this.lang), 1, this.messageService.close(this.lang));
        }
      }
    )
  }

  get_bg(row_id: number) {
    //this.row_id = row_id;
  }

  arrowDownEvent() {
    //this.row_id = row_id;
  }

  select(id: number, title: string) {
    this.matDialogRef.close({ id: id, title: title });
  }//end select

  //*******************************************************************************
  get_amount() {
    this.sum_all = 0;
    for (var i = 0; i < this.list_record.length; i++) {
      this.sum_all += this.list_record[i].sum;
    }
    this.sum_all_letter = Num2persian(this.sum_all);
  }


  delete(id: number) {
    var confirm_delete;
    confirm_delete = window.confirm(this.serverService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var obj = {
        'address': 10566, "user_id": this.user_id, 'id': id
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            this.list_record.splice(this.list_record.findIndex((index: any) => index.wharehouse_order_id == id), 1);
            this.dataSource.data = this.list_record;
            this.get_amount();
            this.message(false, "", 1, this.messageService.close(this.lang));
          }//end if
          else {
            var pe_message = "خطا در حذف";
            this.message(true, this.messageService.message(this.lang, pe_message, ''), 1, this.messageService.close(this.lang));
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete



  load_services(id: number) {
    var where = "";
    var code_id;
    if (id == 220) {
      where += " and wharehouse_material_cate2_cate = " + this.cate;
    }
    if (id == 171) {
      code_id = 10563;
    }
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, where: where, code_id: code_id, obj: { cate2: this.form1.value.cate2 } }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 220) {
            this.form1.patchValue({
              'cate2': res.id,
              'cate2_title': res.title,
              'material': null,
              'material_title': null
            })
          }
          if (id == 171) {
            this.form1.patchValue({
              'material': res.id,
              'material_title': res.title
            })
            this.get_weight(res.id);
          }
        }
      }
    )
  }

  get_weight(material: number) {
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 10643, material: material }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.weight = res['result'][0].wharehouse_material_weight;
          }
          this.message(false, "", 1, this.messageService.close(this.lang));
        }//end if 
        else {
          this.message(true, this.messageService.erorr_in_load(this.lang), 1, this.messageService.close(this.lang));
        }
      }
    )
  }

  open_detaile(i: number, id: number, title: string) {
    const dialogRef = this.dialog.open(CkdMaterial2DetaileComponent, {
      width: '45rem',
      height: 'auto',
      disableClose: true,
      data: { type_task: 2, id: id, i: i, title: title, tip: this.tip, seleton_id: this.seleton_id }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.list_record[i].wharehouse_order_cost = res.result.wharehouse_order_cost;
          this.list_record[i].wharehouse_order_discount = res.result.wharehouse_order_discount;
          this.list_record[i].zarayeb = res.result.zarayeb;
          this.list_record[i].wharehouse_order_number = res.result.wharehouse_order_number;
          this.list_record[i].sum = res.result.sum;
          this.get_amount();
        }
      }
    )
  }


  reset_input(id: number) {
    if (id == 220) {
      this.form1.patchValue({
        'cate2': null,
        'cate2_title': null,
        'material': null,
        'material_title': null
      })
    }
    if (id == 171) {
      this.form1.patchValue({
        'material': null,
        'material_title': null
      })
    }
  }


  close() {
    this.matDialogRef.close({ count: this.list_record.length, sum: this.sum_all });
  }

  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}